module.exports = __webpack_public_path__ + "media/icons/key-delete-722b207d.svg";